module.exports = __webpack_public_path__ + "img/frenchdog.71919fe9.png";